import React from 'react'
import classNames from 'classnames'
import useStore from '@/store'
import type { Props } from './types'
import styles from './style.module.scss'

const CloseButton: React.FC<Props> = ({ type, extraClasses, clickHandler }) => {
  const sounds = useStore((state) => state.sounds)
  const classes = classNames(styles['close-button'], [
    [styles[`close-button--type-${type}`]],
    [extraClasses],
  ])

  function onClick() {
    sounds?.click1?.play()
    clickHandler()
  }

  return (
    <button className={classes} onClick={() => onClick()}>
      {type !== 'idle' &&
        (type === 'resident' ? (
          <img
            src={require('@/assets/images/arrow-back.svg').default}
            alt="back"
          />
        ) : (
          '✕'
        ))}
    </button>
  )
}

export default CloseButton
